import React from "react";
import dateFormat from "dateformat";
import { sha256 } from "js-sha256";
import { AxiosConfiguration } from "./AxiosConfig";
import * as Constant from "./constants";

export let encodeURL = (url) => {
  return sha256(url);
};

export let generate_company_ID = (manufacturer_id) => {
  return `M${manufacturer_id}`;
};

export let generateParticipantGroupID = (siteID, participantGroupID) => {
  return `ST${siteID}PG${participantGroupID}`;
};

export let generateSurveyID = (siteID, surveyID) => {
  return `ST${siteID}S${surveyID}`;
};

export let generateDeviceID = (siteID, deviceID) => {
  return `ST${siteID}D${deviceID}`;
};

export let generateSiteID = (siteID) => {
  return `ST${siteID}`;
};

export let generateSurveyAnalysisReportID = (surveyID, surveyReportID) => {
  return `S${surveyID}SR${surveyReportID}`;
};

export let get_Date = (datetime) => {
  return dateFormat(datetime, "dd-mmmm-yyyy");
  // dateFormat("2019-04-30T08:59:00.000Z", "dddd, mmmm dS, yyyy") to get Tuesday, April 30th, 2019.
};

/* 
  Purpose:    Used to get the maufacturer name only (getting name on the behalf of manufacturer ID)
  Created By: Vinit Kumar 
*/
export const getManufacturerName = (manufacturerID) => {
  const axiosInstance = AxiosConfiguration();
  const bodyFormData = new FormData();
  bodyFormData.append("manufacturer_id", manufacturerID);

  return axiosInstance
    .post("v1/manufacturer_detail/", bodyFormData)
    .then((response) => {
      if (response.data.data) {
        return response.data.data[0].company_name;
      } else {
        return response.data.message;
      }
    })
    .catch((error) => {
      return Constant.API_ERROR;
    });
};

/* 
  Purpose:    Used to get the country list only
  Created By: Vinit Kumar 
*/
export const getCountriesDropdown = (region_id) => {
  const axiosInstance = AxiosConfiguration();
  let bodyFormData = new FormData();
  bodyFormData.append("region_id", region_id);
  return axiosInstance
    .post("v1/get_countrybyregion/", bodyFormData)
    .then((response) => {
      if (response.data.data) {
        let optionItems = response.data.data.map((item) => (
          <option key={item.country_id} value={item.country_id}>
            {item.country_name}
          </option>
        ));
        return {
          status: "success",
          optionItems: optionItems,
        };
      } else {
        return {
          status: "failure",
          message: Constant.API_ERROR,
        };
      }
    })
    .catch((error) => {
      return {
        status: "error",
        message: Constant.API_ERROR,
      };
    });
};

/* 
  Purpose:    Used to get the state list by country ID
  Created By: Vinit Kumar 
*/

export const getStatesDropdowns = (countryID) => {
  const axiosInstance = AxiosConfiguration();
  let bodyFormData = new FormData();
  bodyFormData.append("country_id", countryID);
  return axiosInstance
    .post("v1/get_state_list/", bodyFormData)
    .then((response) => {
      if (response.data.data) {
        let optionItems = response.data.data.map((item) => (
          <option key={item.state_id} value={item.state_id}>
            {item.state_name}
          </option>
        ));
        return {
          status: "success",
          optionItems: optionItems,
        };
      } else {
        return {
          status: "failure",
          message: Constant.API_ERROR,
        };
      }
    })
    .catch((error) => {
      return {
        status: "error",
        message: Constant.API_ERROR,
      };
    });
};

/* 
  Purpose:   Used to get the state list by country ID for doctor
  Created By: Dinesh Kumar 
*/

export const getDoctorStatesDropdowns = (countryID) => {
  const axiosInstance = AxiosConfiguration();
  let bodyFormData = new FormData();
  bodyFormData.append("country_id", countryID);
  return axiosInstance
    .post("v1/get_state_doctor_list/", bodyFormData)
    .then((response) => {
      if (response.data.data) {
        let optionItems = response.data.data.map((item) => (
          <option key={item.state_id} value={item.state_id}>
            {item.state_name}
          </option>
        ));
        return {
          status: "success",
          optionItems: optionItems,
        };
      } else {
        return {
          status: "failure",
          message: Constant.API_ERROR,
        };
      }
    })
    .catch((error) => {
      return {
        status: "error",
        message: Constant.API_ERROR,
      };
    });
};

/* 
  Purpose:    Used to get region list
  Created By: Vinit Kumar 
*/
export const getRegionDropdown = () => {
  const axiosInstance = AxiosConfiguration();
  return axiosInstance
    .post("v1/get_region_list/")
    .then((response) => {
      if (response.data.data) {
        let optionItems = response.data.data.map((item) => (
          <option key={item.region_id} value={item.region_id}>
            {item.region_name}
          </option>
        ));
        return {
          status: "success",
          optionItems: optionItems,
        };
      } else {
        return {
          status: "failure",
          message: Constant.API_ERROR,
        };
      }
    })
    .catch((error) => {
      return {
        status: "error",
        message: Constant.API_ERROR,
      };
    });
};
/* 
  Purpose:    Used to get profession list
  Created By: Vinit Kumar 
*/

export const getCategoryDropdown = () => {
  const axiosInstance = AxiosConfiguration();
  return axiosInstance
    .post("v1/get_category_list/")
    .then((response) => {
      if (response.data.data) {
        let optionItems = response.data.data.map((item) => (
          <option key={item.category_id} value={item.category_id}>
            {item.category_name}
          </option>
        ));
        return {
          status: "success",
          optionItems: optionItems,
        };
      } else {
        return {
          status: "failure",
          message: Constant.API_ERROR,
        };
      }
    })
    .catch((error) => {
      return {
        status: "error",
        message: Constant.API_ERROR,
      };
    });
};

/* 
  Purpose:    Used to get profession list
  Created By: Vinit Kumar 
*/
export const getProfessionDropdown = (category_id) => {
  const axiosInstance = AxiosConfiguration();
  let bodyFormData = new FormData();
  bodyFormData.append("category_id", category_id);
  return axiosInstance
    .post("v1/get_profession_list/", bodyFormData)
    .then((response) => {
      if (response.data.data) {
        let optionItems = response.data.data.map((item) => (
          <option key={item.profession_id} value={item.profession_id}>
            {item.profession_name}
          </option>
        ));
        return {
          status: "success",
          optionItems: optionItems,
        };
      } else {
        return {
          status: "failure",
          message: Constant.API_ERROR,
        };
      }
    })
    .catch((error) => {
      return {
        status: "error",
        message: Constant.API_ERROR,
      };
    });
};

/* 
  Purpose:  Used to get participant qalifications by surveyId
  Created By: Dinesh Kumar 
*/
export const getParticipantQalificationsBySurveyId = (survey_id) => {
  let bodyFormData = new FormData();
  bodyFormData.append("survey_id", survey_id);
  const axiosInstance = AxiosConfiguration();
  return axiosInstance
    .post("v1/get_survey_participant_qualification/", bodyFormData)
    .then((response) => {
      if (response.data.data) {
        return {
          status: "success",
          data: JSON.parse(
            response.data.data[0]["participant_qualification_json"]
          ),
        };
      } else {
        return {
          status: "failure",
          message: Constant.API_ERROR,
        };
      }
    })
    .catch((error) => {
      return {
        status: "error",
        message: Constant.API_ERROR,
      };
    });
};

/*
 * Replace survey _ to space
 */

export const getSurveyStatusName = (survey_status) => {
  if (survey_status === "final_save") {
    return "Completed";
  } else {
    if (survey_status === "draft_released_to_primary_user") {
      return "Draft created";
    } else {
      return capitalizeFirst(survey_status.replace("_", " "));
    }
  }
};
export const capitalizeFirst = (str) => {
  return str.charAt(0).toUpperCase() + str.slice(1);
};

/* Get array data*/
export const getDataArr = (dataObj) => {
  let selectedDataArr = [];
  for (let key in dataObj) {
    if (dataObj.hasOwnProperty(key)) {
      selectedDataArr.push(dataObj[key].value);
    }
  }
  return selectedDataArr;
};
// only number value
export const onlyNumber = (number) => {
  let value = number.replace(/\D/g, "");
  return value;
};

//Get current date

export const minCurrentDate = () => {
  const dt = new Date();
  const year = dt.getFullYear();
  const month = (dt.getMonth() + 1).toString().padStart(2, "0");
  const day = dt.getDate().toString().padStart(2, "0");
  const currentDate = year + "-" + month + "-" + day;
  return currentDate;
};

//Date formate for complitetion date in server
export let getCompleteSurveyDate = (datetime) => {
  return dateFormat(datetime, "yyyy-mm-dd");
};

export const commaSeprateString = (str) => {
  if (str !== "") {
    return str.slice(1, -1).replace(/'/g, "");
  } else {
    return "";
  }
};

/* Get Time with AM / PM notations
   Created by : Pankaj */
export const time_with_AMPM = (dateInput) => {
  const d = new Date(dateInput);
  const ampm = d.getUTCHours() >= 12 ? "PM" : "AM";
  const hours = d.getUTCHours() > 12 ? d.getUTCHours() - 12 : d.getUTCHours();
  const minutes = d.getUTCMinutes() < 10 ? "0" + d.getUTCMinutes() : d.getUTCMinutes();
  return hours + ":" + minutes + " " + ampm;
};
